import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/Union.png'


const _withScopeId = n => (_pushScopeId("data-v-6906f424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "姓名", -1))
const _hoisted_5 = { class: "id" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "身份证号", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idphoto1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "证件照片"),
  /*#__PURE__*/_createElementVNode("span", null, "已上传")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.show
            ? _ctx.getInformation.data.card_id.replace(
                /^(.{1})(?:\w+)(.{1})$/,
                "\$1***************\$2"
              )
            : _ctx.getInformation.data.card_id), 1),
        _createElementVNode("i", {
          class: _normalizeClass(["iconfont icon-yanjing_yincang", { 'icon-yanjing_xianshi': _ctx.show == false }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideNumber && _ctx.hideNumber(...args)))
        }, null, 2)
      ]),
      _hoisted_7,
      _hoisted_8
    ])
  ]))
}